import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withRadium, DetectThresholds, keyframes } from 'higher-order-components'
import { getErrorMessage } from 'apis/geo'
import { actionCreators, selectors } from 'store/actions/location'
import { postcodeValidation } from 'utils/validation'
import { ToastPopup } from 'AtomicComponents'
import { LoaderIcon, InputText, Button, Heading } from 'components'
import { noop } from 'utils'
import { WINDOW } from "AtomicUtils/environment"
import postcodePopUpStyles from './postcode-popup.less'
import classnames from "classnames"
import gtmHandler from "AtomicUtils/gtmHandler"
// Redux
import { connect } from 'react-redux'
import crosshairs from './crosshairs.svg'
import { ConnectLocation } from 'higher-order-components'
class PostcodePopup extends PureComponent {
  constructor(props) {
    super(props)
    //const { postcode } = this.props.locationState
     //- 2601
    const { postcode } = this.props.locationState;

    this.state = {
      // Decouple from props since we only want to update postcode on submit
      postcode,
      isEditing: false,
      validationError: '',
      focus: false,
      open: false,
    }
  }

  handlePostcodeInputChange = ({ target }) => {
    const { value } = target
    const number = value.replace(/[^0-9]/g, '')
    var post = 2601;
    this.setState({
      postcode: '2601',
      validationError: ''
    })
  }

  handlePostcodeInputFocus = () => {
    this.setState({ isEditing: true, focus: true })
  }

  handlePostcodeInputBlur = () => {
    this.setState({ isEditing: false, focus: false })
  }

  submitPostcode = (event) => {
    //this.state
    const { postcode } = this.state
    this.handlePostcodeInputBlur()
    if (event) event.preventDefault()

    //const { isValid, message } = postcodeValidation(postcode ? postcode.toString() : '')
    const isValid = true;
    if (!isValid) {
      this.setState({ validationError: message })
    } else {
      this.setState({
        open: false,
      })
      //this.props.locationActions.updatePostcode(postcode)
      this.props.locationActions.updatePostcode('2601')
    }
  }

  componentWillReceiveProps({ locationState }) {
    if (this.state.isEditing) return

    const {
      fetchError, postcode, isFetching, postcodePopupOpen
    } = locationState

    const shouldFocus =
      postcodePopupOpen &&
      (fetchError || postcodePopupOpen !== this.props.locationState.postcodePopupOpen)

    this.setState({
      ...(fetchError ? { validationError: getErrorMessage(fetchError) } : {}),
      ...(postcode && !isFetching && !fetchError ? { postcode } : {}),
      ...(shouldFocus ? { focus: true } : {})
    })
  }

  componentDidMount() {
    if (this.props.postcodePopupOpenAutomatically && !this.props.locationState.postcode) {
      const { requestPostcodeInput } = this.props.locationActions
      requestPostcodeInput()
    }
    WINDOW.addEventListener(
      "POSTCODE_POPUP_OPEN",
      () => this._handleOpen(),
      false
    )
  }

  _handleOpen = () => {
    this.setState({
      open: true
    })
  }

  getTitle() {
    const { postcode, locationConfirmed } = this.props.locationState

    if (!postcode) return 'Set your location'
    return locationConfirmed ? 'Change your location' : 'Confirm your location'
  }

  getMessage(styles) {
    const { postcode } = this.state
    const { postcode: propsPostcode } = this.props.locationState

    return propsPostcode ? (
      <span style={styles.span}>
        Your current postcode <strong>{postcode}</strong> will be used to determine prices. Is this
        correct?
      </span>
    ) : (
        <span style={styles.span}>Your postcode will be used to determine prices.</span>
      )
  }

  handleClose = () => {
    const { cancelPostcodeInput } = this.props.locationActions
    gtmHandler({
      pageCategory: "Postcode Pop-up",
      pageAction: "Postcode Pop-up - closed"
    })
    cancelPostcodeInput()
    this.setState({
      open: false,
    })
  }

  render() {
    const { isFetching } = this.props.locationState
    const { postcode, validationError, focus, open } = this.state
    const styles = PostcodePopupStyles(this.props.thresholds)
    const show = this.props.locationState.postcodePopupOpen || open

    if (!show) return null

    return (
      <div>
        <ToastPopup onClose={this.handleClose}>
          <div className={classnames({
            [postcodePopUpStyles.PostCodePopup]: true,
          })}>
            <div className={classnames({
              [postcodePopUpStyles.First]: true,
            })}>
              <div style={styles.crosshairs} />
              <div>
                <Heading
                  withDetails
                  value={this.getTitle()} tag="h5" applyTopMargin={false} />
                {this.getMessage(styles)}
              </div>
            </div>
            <form className={classnames({
              [postcodePopUpStyles.Form]: true,
            })} onSubmit={this.submitPostcode}>
              <div className={classnames({
                [postcodePopUpStyles.Input]: true,
              })} >
                <InputText
                  ref={(c) => {
                    this.postcodeInput = c
                  }}
                  value={postcode}
                  placeholder={'Enter your postcode'}
                  isValid={!validationError}
                  maxLength={4}
                  message={validationError || ''}
                  onChange={this.handlePostcodeInputChange}
                  onFocus={this.handlePostcodeInputFocus}
                  onBlur={this.handlePostcodeInputBlur}
                  disabled={isFetching}
                  focus={focus}
                  margin="0"
                  styleName="dark" />
              </div>
              <div>
                {isFetching && (
                  <div style={{ position: 'absolute', left: '66%', top: '26%' }}>
                    <LoaderIcon styleName="light" />
                  </div>
                )}
                {/* Keep button around to maintain width */}
                <div style={isFetching ? { opacity: 0, pointerEvents: 'none' } : null}>
                  <Button label="Submit" display="block" onClick={this.submitPostcode} />
                </div>
              </div>
            </form>
          </div>
        </ToastPopup>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  locationState: selectors.getLocation(state)
})

const mapDispatchToProps = dispatch => ({
  locationActions: Object.keys(actionCreators).reduce((actions, key) => {
    actions[key] = (...args) => dispatch(actionCreators[key](...args))
    return actions
  }, {})
})

export default withRadium(DetectThresholds(), ConnectLocation(), connect(mapStateToProps, mapDispatchToProps))(PostcodePopup)

PostcodePopup.propTypes = {
  locationState: PropTypes.object,
  locationActions: PropTypes.object,
  postcodePopupOpenAutomatically: PropTypes.bool,
  thresholds: PropTypes.shape({
    compact: PropTypes.bool,
    wide: PropTypes.bool
  })
}

PostcodePopup.defaultProps = {
  locationState: {},
  postcodePopupOpenAutomatically: false,
  locationActions: {
    cancelPostcodeInput: noop,
    updatePostcode: noop,
    fetchLocation: noop
  },
  thresholds: {
    compact: true,
    wide: false
  }
}

const rotateKeyframes = keyframes({
  '0%': {
    transform: 'rotate(0deg)'
  },
  '33%, 100%': {
    transform: 'rotate(90deg)'
  }
})

const PostcodePopupStyles = ({ compact, wide }) => ({
  span: {
    display: 'inline-block',
    width: '100%',
    lineHeight: 1.4
  },
  wrapper: {
    display: "flex",
    textAlign: "center",
    flexGrow: 1,
    alignItems: "center",
    minHeight: '120px',
    width: '100%',
    flexDirection: "column",
    ...(compact
      ? {}
      : {
        paddingRight: "2em",
        textAlign: "left",
        flexDirection: "row"
      })
  },
  content: {
    flexGrow: 1,
    textAlign: compact ? 'center' : 'left',
    maxWidth: !compact && '42vw',
    marginLeft: wide && '2em',
    borderLeft: wide && '1px solid #d5d5d5',
    paddingLeft: wide && '2em'
  },
  actions: {
    display: 'flex',
    width: '100%',
    padding: '0 15px',
    margin: '0 auto',
    flexGrow: 0,
    flexDirection: compact ? 'column' : 'row',
    justifyContent: compact ? 'center' : 'flex-end',
    alignItems: 'center',
    flexShrink: 10
  },
  inputContainer: {
    flexGrow: 0,
    width: '100%',
    marginRight: !compact && '1em',
    marginTop: '-10px',
    height: compact ? '140px' : '115px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  buttonContainer: {
    flexGrow: 0,
    flexShrink: 0,
    position: 'relative'
  },
  crosshairs: {
    animation: 'x 2s infinite ease-in-out',
    animationName: rotateKeyframes,
    margin: '15px',
    display: wide ? 'block' : 'none',
    ...(wide
      ? {
        width: '2em',
        height: '2em',
        flex: '0 0 2em',
        backgroundImage: `url(${crosshairs})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center'
      }
      : {})
  }
})



// WEBPACK FOOTER //
// ./src/containers/postcode-popup/index.jsx